import ForeignHealthInsuranceTypeForm from '@/modules/foreign-health/rater/views/forms/ForeignHealthInsuranceTypeForm.vue'
import ForeignHealthDurationForm from '@/modules/foreign-health/rater/views/forms/ForeignHealthDurationForm.vue'
import type FormPage from '@/modules/common/common/models/APP/FormPage'
import ForWhomForm from '@/modules/common/rater/views/forms/ForWhomForm.vue'
import MoreInfoForm from '@/modules/common/rater/views/forms/MoreInfoForm.vue'
import StartDateForm from '@/modules/common/rater/views/forms/StartDateForm.vue'

export default {
  ForWhom: {
    form: ForWhomForm,
    next: ['ForeignHealthInsuranceType']
  },
  ForeignHealthInsuranceType: {
    form: ForeignHealthInsuranceTypeForm,
    next: ['ForeignHealthDurationForm', 'StartDateForm']
  },
  StartDateForm: {
    form: StartDateForm,
    next: ['MoreInfoForm'],
    extra: {
      minDays: -7
    }
  },
  ForeignHealthDurationForm: {
    form: ForeignHealthDurationForm,
    next: ['MoreInfoForm']
  },
  MoreInfoForm: {
    form: MoreInfoForm,
    next: [],
    extra: { useTooOldGreaterOrEqual: true }
  }
} as Record<string, FormPage>
